import * as firebase from "firebase/app";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";

var firebaseConfig = {
    apiKey: "AIzaSyDpgWgYG4H76dR9SEo-KrPLccX63bY93XM",
    authDomain: "task-tracker-7074f.firebaseapp.com",
    databaseURL: "https://task-tracker-7074f.firebaseio.com",
    projectId: "task-tracker-7074f",
    storageBucket: "task-tracker-7074f.appspot.com",
    messagingSenderId: "63848615551",
    appId: "1:63848615551:web:a8ca90ac934bd58b"
};
// Initialize Firebase

firebase.initializeApp(firebaseConfig);

firebase.firestore().enablePersistence()
  .catch(function(err) {
      if (err.code == 'failed-precondition') {
          console.log("multiple tabs open");
          // Multiple tabs open, persistence can only be enabled
          // in one tab at a a time.
          // ...
      } else if (err.code == 'unimplemented') {
          console.log("current broweser does not support");
          // The current browser does not support all of the
          // features required to enable persistence
          // ...
      }
  });

module.exports = firebase;


// WEBPACK FOOTER //
// ./src/container/firebase.js